module.exports = __webpack_public_path__ + "img/border_Ellipse_3D_White.d154d0eb.svg";